import { Component, EventEmitter, Input, NgZone, OnChanges, Output, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { take } from 'rxjs/operators';
import { process, State } from '@progress/kendo-data-query';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { CRMService } from '../../services/crm.service';
import { CSEService } from '../../services/cse.service';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    Opportunity
    , Product
    , QuoteOrder
    , QuoteOrderCopy
    , QuoteOrderLine
    , RateIndex
    , SearchCarrierContract
    , SearchQuoteOrder
} from '../../models/models';

@Component({
    selector: 'quoteordermaster-form',
    templateUrl: './quoteordermaster-form.component.html',
    standalone: false
})
export class QuoteOrderMasterForm implements OnChanges {
    @Input() quoteOrderMaster: SearchQuoteOrder = {} as SearchQuoteOrder;
    @Output() onRefresh = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public orderCopySaveGrid!: GridComponent;

    public isBeginDateValid: boolean = true;
    public isEndDateValid: boolean = true;
    public isInit: boolean = true;
    public maxCopies: number = 60;
    public maxAutoTenderDays: number = 13;
    public numCopies: number = 0;
    public numDays: number = 0;
    public orderCopy: QuoteOrderCopy = {} as QuoteOrderCopy;

    public quoteOrder: QuoteOrder = {} as QuoteOrder;
    public opportunity: Opportunity = {} as Opportunity;
    public orderList: QuoteOrder[] = [];
    public quoteOrderLineList: QuoteOrderLine[] = [];
    public productList: Product[] = [];
    public opportunityList: Opportunity[] = [];
    public rateIndexList: RateIndex[] = [];
    private copyOrderDefaultDateRange: number = 7;

    public isAutoTender: boolean = false;
    public contractList: SearchCarrierContract[] = [];
    public isValid: boolean = false;
    public validationWarningList: string[] = [];

    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'quoteOrderID' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private applicationControlService: ApplicationControlService, private cseService: CSEService,
        private crmService: CRMService, private orderService: OrderService, private ngZone: NgZone,
        private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.setApplicationControls();
        this.getProducts();
        this.getRateIndexes();
        //this.getQuoteOrder();
        console.log("ngOnInit", this.quoteOrderMaster);
    }

    ngOnChanges() {
        //this.orderCopy.beginDate = new Date(this.quoteOrderMaster.originalPickupDate);
        //this.orderCopy.endDate = new Date(this.quoteOrderMaster.originalPickupDate);
        var pickupDate: Date = new Date(this.quoteOrderMaster.originalPickupDate);
        var today: Date = new Date();
        this.orderCopy.beginDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), pickupDate.getHours(), pickupDate.getMinutes(), 0);
        this.orderCopy.endDate = this.utilService.addDays(this.orderCopy.beginDate, this.copyOrderDefaultDateRange);
        //this.getProducts();
        //this.getRateIndexes();
        this.getQuoteOrder();
        this.getQuoteOrderLines();
        console.log("ngOnChanges", this.quoteOrderMaster);
    }

    private setApplicationControls() {
        this.applicationControlService.getApplicationControlsByAppName("CopyOrderDefaultDateRange").subscribe(result => {
            if (result.length > 0) {
                this.copyOrderDefaultDateRange = parseInt(result[0].appSettingValue);
                if (this.orderCopy) {
                    this.orderCopy.endDate = this.utilService.addDays(new Date(), this.copyOrderDefaultDateRange);
                }
            }
        });
        this.applicationControlService.getApplicationControlsByAppName("MaxAutoTenderDays").subscribe(result => {
            if (result.length > 0) {
                this.maxAutoTenderDays = parseInt(result[0].appSettingValue);
            }
        });
    }

    private getQuoteOrder() {
        this.orderService.getQuoteOrderByID(this.quoteOrderMaster.quoteOrderID).subscribe(result => {
            this.quoteOrder = result.resultCollection[0];
            this.getOpportunityByID(this.quoteOrderMaster.opportunityID);
        });
    }

    private getQuoteOrderLines() {
        this.orderService.getQuoteOrderLinesByQuoteOrderID(this.quoteOrderMaster.quoteOrderID).subscribe(result => {
            this.quoteOrderLineList = result.resultCollection;
            this.isAutoTender = false;
            for (var i = 0; i < this.quoteOrderLineList.length; i++) {
                if (this.quoteOrderLineList[i].isAutoTender == true) {
                    this.isAutoTender = true;
                }
            }
            if (this.isAutoTender) {
                this.getSearchCarrierContract();
            }
        });
    }

    private getSearchCarrierContract() {
        this.cseService.getSearchCarrierContractByQuoteOrderID(this.quoteOrderMaster.quoteOrderID).subscribe(result => {
            this.contractList = result.resultCollection;
            this.validationWarningList = [];
            for (var i = 0; i < this.contractList.length; i++) {
                if (this.contractList[i].isAutoTender) {
                    this.validateContract(this.contractList[i]);
                }
            }
        });
    }

    private getRateIndexes() {
        this.crmService.getRateIndices().subscribe(result => {
            this.rateIndexList = result;
        });
    }

    private getProducts() {
        this.orderService.getProducts().subscribe(result => {
            this.productList = result.filter(t => t.isOrderEntryCompatible == true);
        });
    }

    private getOpportunityByID(opportunityID: number) {
        this.crmService.getOpportunityById(opportunityID).subscribe(result => {
            if (result != null) {
                this.opportunity = result;
                console.log("getOpportunityByID", opportunityID, this.opportunity);
                this.productChanged(result.productId);
            }
            else {
                this.opportunity = {} as Opportunity;
            }
        });
    }

    private getOpportunities(customerId: number, productId: number, productName: string) {
        this.crmService.getOpportunitiesByCustomerIdProductId(customerId, productId).subscribe(result => {
            // need to add new opportunity if it doesn't exist
            // Spot-Unknown : for Spot/Expedite RateIndex
            // Contract-Unknown : for Contract RateIndex
            var rateIndex = this.rateIndexList.find(t => t.rateIndexID == this.quoteOrderMaster.rateIndexID);
            var notes = "UNKNOWN";
            if (rateIndex != null) {
                if (rateIndex.description == "Contract") {
                    notes = "Contract - Unknown";
                }
                else {
                    notes = "Spot - Unknown";
                }
            }
            if (productName == "Consol/Deconsol") {
                notes = "Consol - Unknown";
            }
            this.opportunityList = Object.assign([], result);
            result = result.filter(t => t.notes != "UNKNOWN" && t.notes == notes);
            if (result.length == 0) {
                var opp: Opportunity = {
                    opportunityID: 0,
                    customerId: customerId,
                    productId: productId,
                    //contactId: 0,
                    //marketingCampaignId: 0,
                    estimatedRevenue: 0,
                    notes: notes,
                    dueDate: new Date(),
                    expectedCloseDate: new Date(),
                    createDate: new Date(),
                    ownerEmployeeId: (this.quoteOrder.orderOwnerEmployeeID == null ? -2 : this.quoteOrder.orderOwnerEmployeeID)
                }
                //console.log("orderCopy:saveOpportunity", customerId, productId, opp);
                this.crmService.saveOpportunity(opp).subscribe(result2 => {
                    //this.opportunityList.length = 0;
                    this.opportunityList.push(result2);
                    if (result2 != null) {
                        this.quoteOrderMaster.opportunityID = result2.opportunityID;
                    }
                    console.log("orderCopy:getOpportunities:saveOpportunity", customerId, productId, opp, result2);
                });
            }
            else {
                var idx = this.opportunityList.findIndex(t => t.opportunityID == this.quoteOrderMaster.opportunityID);
                if (idx < 0) {
                    idx = this.opportunityList.findIndex(t => t.notes.indexOf(" - Unknown") >= 0);
                    if (idx >= 0) {
                        this.quoteOrderMaster.opportunityID = this.opportunityList[idx].opportunityID;
                    }
                }
            }
            console.log("orderCopy:getOpportunities", customerId, productId, this.quoteOrderMaster.opportunityID, this.opportunityList);

            //if (this.billToID > 0) {
            //    this.getQuoteOrderHeaders(this.billToID, this.quoteOrder.opportunityId);
            //}

            //if (this.quoteOrderLine != null && this.quoteOrderLine.quoteOrder != null)
            //    this.getQuoteOrderHeaders(this.quoteOrderLine.quoteOrder.customerId, this.quoteOrderLine.quoteOrder.opportunityId);
        });
    }

    public productChanged(evt: any) {
        var productID = evt.target ? evt.target.value : evt;
        var product = this.productList.find(t => t.productId == productID);
        if (product != null && product.defaultRateIndexId != null) {
            this.quoteOrderMaster.rateIndexID = product.defaultRateIndexId;
        }

        console.log("productChanged", productID, this.isInit, this.quoteOrderMaster.opportunityID, product);
        if (this.isInit) {
            this.isInit = false;
        }
        else {
            this.quoteOrderMaster.opportunityID = -1;
        }
        this.getOpportunities(this.quoteOrder.customerID, productID, product!.productName);
    }

    public dateChanged(field: string) {
        //this.utilService.getDateAsUTC(
        //console.log("dateChanged:local", source, field, this.shipperEarliestDate, this.shipperLatestDate, this.consigneeEarliestDate, this.consigneeLatestDate);
        //console.log("dateChanged:UTC", source, field, this.utilService.getDateAsUTC(this.shipperEarliestDate), this.utilService.getDateAsUTC(this.shipperLatestDate), this.utilService.getDateAsUTC(this.consigneeEarliestDate), this.utilService.getDateAsUTC(this.consigneeLatestDate));
        this.isBeginDateValid = true;
        this.isEndDateValid = true;
        var minDate: Date = new Date();
        minDate.setHours(0);
        minDate.setMinutes(0);
        minDate.setSeconds(0);

        if (this.orderCopy.beginDate >= this.orderCopy.endDate) {
            if (field == "beginDate") {
                this.orderCopy.endDate = new Date(this.orderCopy.beginDate);
            }
            else {
                this.isBeginDateValid = false;
                this.isEndDateValid = false;
            }
        }
        if (this.orderCopy.beginDate < minDate) {
            this.isBeginDateValid = false;
        }
    //    if (this.minStopDate && this.orderCopy.beginDate <= this.minStopDate
    //        || this.maxStopDate && this.orderCopy.beginDate >= this.maxStopDate) {
    //        this.isBeginDateValid = false;
    //    }
    }

    private validateFields() {
        var isValid: boolean = true;
        if (!this.isBeginDateValid || !this.isEndDateValid || !this.checkNumberOfCopies()) {
            isValid = false;
        }
        if (!isValid) {
            this.notificationService.showWarning("Please correct required fields", "WARNING: Fields Required");
        }
        return isValid;
    }

    private checkNumberOfCopies() {
        var isValid: boolean = true;
        var numDays: number = 0;
        var numWeekdays: number = 0;
        this.numCopies = 0;
        numDays = this.utilService.getDateDiffDays(this.orderCopy.beginDate, this.orderCopy.endDate);
        if (this.orderCopy.isMonday) {
            numWeekdays++;
        }
        if (this.orderCopy.isTuesday) {
            numWeekdays++;
        }
        if (this.orderCopy.isWednesday) {
            numWeekdays++;
        }
        if (this.orderCopy.isThursday) {
            numWeekdays++;
        }
        if (this.orderCopy.isFriday) {
            numWeekdays++;
        }
        if (this.orderCopy.isSaturday) {
            numWeekdays++;
        }
        if (this.orderCopy.isSunday) {
            numWeekdays++;
        }
        this.numCopies = Math.round(numDays / 7 * numWeekdays);
        if (this.numCopies > this.maxCopies) {
            isValid = false;
        }
        if (this.isAutoTender && this.numDays > this.maxAutoTenderDays) {
            isValid = false;
        }
        return isValid;
    }

    public save() {
        this.orderCopy.quoteOrderID = this.quoteOrderMaster.quoteOrderID;
        this.orderCopy.employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        this.orderCopy.beginDate = this.utilService.getDateAsUTC(this.orderCopy.beginDate);
        this.orderCopy.endDate = this.utilService.getDateAsUTC(this.orderCopy.endDate);
        console.log("save", this.orderCopy);
        if (this.validateFields()) {
            this.utilService.isLoading = true;
            this.orderService.saveQuoteOrderCopy(this.orderCopy, false).subscribe(result2 => {
                this.utilService.isLoading = false;
                if (result2.resultCollection.length > 0) {
                    this.orderList = result2.resultCollection;
                    this.setGrid();
                    console.log("quoteordermaster-form:save", this.orderList);
                    this.notificationService.showSuccess("Created " + this.orderList.length + " order copies.", "SUCCESS: Copy Order");
                    this.orderCopy = {} as QuoteOrderCopy;
                    this.quoteOrderMaster = {} as SearchQuoteOrder;
                    //this.onRefresh.emit();
                } else {
                    this.utilService.isLoading = false;
                    this.notificationService.showError("Failed to copy order.", "ERROR: Failed to Copy");
                }
            });
        }
    }

    public saveQuoteOrder() {
        //this.quoteOrder.description = this.orderCopy.scheduleDescription;
        //this.quoteOrder.description = this.orderCopy.scheduleDescription;
        //if (this.quoteOrder.orderOwnerEmployeeID == null) {
        //    this.quoteOrder.orderOwnerEmployeeID = -2;
        //}
        console.log("save:saveQuoteOrder", this.quoteOrder);
        this.orderService.saveQuoteOrder(this.quoteOrder).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.quoteOrder = result.resultCollection[0];
                this.onRefresh.emit();
            } else {
                this.utilService.isLoading = false;
                this.notificationService.showError("Failed to save order fields.", "ERROR: Failed to Save");
            }
        });
    }

    public cancel() {
        this.orderCopy = {} as QuoteOrderCopy;
        this.quoteOrderMaster = {} as SearchQuoteOrder;
        this.orderList.length = 0;
        this.onRefresh.emit();
    }

    private setGrid() {
        this.gridData = process(this.orderList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.orderCopySaveGrid == null) return;
            this.orderCopySaveGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.orderList, this.gridState);
    }

    private validateContract(contract: SearchCarrierContract) {
        this.isValid = true;
        this.validationWarningList.length = 0;
        if (contract.isExpired) {
            this.isValid = false;
            this.validationWarningList.push("Leg " + contract.legNumber + ": contract is EXPIRED");
        }
        else {
            if (contract.carrierContactID == null) {
                this.isValid = false;
                this.validationWarningList.push("Leg " + contract.legNumber + ": missing Carrier Contact");
            }
            //if (contract.isMacropointRequired == true && contract.macropointTrackType == "Mobile" && (contract.driverCell == null || contract.driverCell == "")) {
            //    this.isValid = false;
            //    this.validationWarningList.push("Leg " + contract.legNumber + ": missing Driver Cell");
            //}
            //if (contract.isMacropointRequired == true && contract.macropointTrackType == "VehicleID" && (contract.truckNumber == null || contract.truckNumber == "")) {
            //    this.isValid = false;
            //    this.validationWarningList.push("Leg " + contract.legNumber + ": missing Truck #");
            //}
            //if (contract.isMacropointRequired == true && contract.macropointTrackType == "TrailerID" && (contract.trailerNumber == null || contract.trailerNumber == "")) {
            //    this.isValid = false;
            //    this.validationWarningList.push("Leg " + contract.legNumber + ": missing Trailer #");
            //}
            if (!contract.awardedCarrierRepID) {
                this.isValid = false;
                this.validationWarningList.push("Leg " + contract.legNumber + ": missing Carrier Rep");
            }
            if (contract.ppcCityID == null) {
                this.isValid = false;
                this.validationWarningList.push("Leg " + contract.legNumber + ": missing PPC City");
            }
            if (contract.offerRate == null || contract.offerRate <= 0) {
                this.isValid = false;
                this.validationWarningList.push("Leg " + contract.legNumber + ": missing Rate");
            }
            if (contract.offerRatePerMile == null || contract.offerRatePerMile <= 0) {
                this.isValid = false;
                this.validationWarningList.push("Leg " + contract.legNumber + ": missing Rate/mi");
            }
            //if (contract.isMacropointRequired && (contract.macropointTrackType == null || contract.macropointTrackType == "")) {
            //    this.isValid = false;
            //    this.validationWarningList.push("Leg " + contract.legNumber + ": missing Macropoint Track Type");
            //}
        }
    }
}
